import {ASSIGNMENT_DESCRIPTION_ACTION_TYPE} from './constants'

export const assignmentDescriptionsRetrieved = (assignmentDescriptions) => ({
   type: ASSIGNMENT_DESCRIPTION_ACTION_TYPE.ASSIGNMENT_DESCRIPTION,
   payload: {
      assignmentDescriptions
   }
});
